import { fetchApi } from "./fetchApi";

export default {
  list({ ownerId, ownerType }) {
    return fetchApi({
      method: "get",
      url: `/api/files?ownerType=${ownerType}&ownerId=${ownerId}`,
    });
  },

  async remove(id) {
    return fetchApi({
      method: "delete",
      url: `/api/files/${id}`,
    });
  },
};
